import { render, staticRenderFns } from "./DelegationNewFromOrderView.vue?vue&type=template&id=44856dce&scoped=true&"
import script from "./DelegationNewFromOrderView.vue?vue&type=script&lang=js&"
export * from "./DelegationNewFromOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44856dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44856dce')) {
      api.createRecord('44856dce', component.options)
    } else {
      api.reload('44856dce', component.options)
    }
    module.hot.accept("./DelegationNewFromOrderView.vue?vue&type=template&id=44856dce&scoped=true&", function () {
      api.rerender('44856dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationNewFromOrderView.vue"
export default component.exports